export const USER_LIST_PARAMETER_NAME = '{|user_id_id_list|}'
export const VOICEBOT_LIST_PARAMETR_NAME = '{|voice_bots|}'
export const CAMPAIGN_LIST_PARAMETER_NAME = '{|campaign_list|}'
export const EXTENSION_LIST_PARAMETER_NAME = '{|extension_list|}'
export const DID_LIST_PARAMETER_NAME = '{|did_list|}'
export const QUESTIONS_PARAMETER_NAME = '{|question|}'
export const AGGREGATE_BY_PARAMETER_NAME = '{|AggregateBy|}'
export const QUEUE_LIST_PARAMETER_NAME = '{|queue_list|}'
export const DISTRIBUTOR_ID_LIST_PARAMETER_NAME = '{|distributor_id_id_list|}'
export const CAMPAIGN_IVR_LIST_PARAMETER_NAME = '{|campaign_ivr_list|}'
export const EXIT_TYPES_LIST_PARAMETER_NAME = '{|exit_types|}'
export const CALL_CUSTOM_VARS_LIST_PARAMETER_NAME = '{|call_custom_vars|}'
export const EMOTION_LIST_PARAMETER_NAME = '{|emotion_list|}'
export const CLIENT_PHONE_PARAMETER_NAME = '{|client_phone|}'
export const PERIOD_TYPE_PARAMETER_NAME = '{|Period_Type|}'
export const SUMMARY_CDR_TEMPLATE_PARAMETER_NAME = '{|Summary_CDR_Template|}'
export const SYSTEM_PROMPT_PARAMETER_NAME = '{|System_Prompt|}'
export const LAYERS_PARAMETER_NAME = '{|layers|}'

export const componentTypes = {
    1: {
        name: 'Input',
        type: 'text'
    },
    2: {
        name: 'Input',
        type: 'number',
        params: {
            min: 0
        }
    },
    3: {
        name: 'Date',
        type: 'date'
    },
    4: {
        name: 'Input',
        type: 'number'
    },
    5: {
        name: 'Select',
        type: 'select'
    },
    6: {
        name: 'AutoComplete',
        type: 'multiple'
    },
    7: {
        name: 'RadioGroup',
        type: 'boolean'
    },
    16: {
        name: 'MultiSelect',
        type: 'multiple'
    }
}
const voicebotListConfig = {
    ParameterName: VOICEBOT_LIST_PARAMETR_NAME,
    EntitiesListKey: 'VoiceBots',
    value: 'BotID',
    label: 'Name'
}
const userListConfig = {
    ParameterName: USER_LIST_PARAMETER_NAME,
    EndPoint: '/User/List/',
    label: 'user_name',
    value: 'user_id',
    EntitiesListKey: 'Users',
    icon: 'IconUsers'
}

const campaignListConfig = {
    ParameterName: CAMPAIGN_LIST_PARAMETER_NAME,
    EndPoint: '/User/List/',
    label: 'camp_name',
    value: 'camp_id',
    EntitiesListKey: 'Campaigns',
    icon: 'IconCampaigns'
}

const extensionListConfig = {
    ParameterName: EXTENSION_LIST_PARAMETER_NAME,
    EndPoint: '/Extension/List/',
    label: 'ext_name',
    second_label: 'ext_name',
    value: 'extension_id',
    EntitiesListKey: 'Extension',
    icon: 'IconExtension'
}

export const didListConfig = {
    ParameterName: DID_LIST_PARAMETER_NAME,
    EndPoint: '/DID/List/',
    label: 'did_name',
    value: 'user_did_id',
    EntitiesListKey: 'DIDs',
    icon: 'IconDids'
}

const queueListConfig = {
    ParameterName: QUEUE_LIST_PARAMETER_NAME,
    EndPoint: '/Queue/List/',
    label: 'q_name',
    value: 'queue_id',
    EntitiesListKey: 'Queues',
    icon: 'IconQueues'
}

const accountListConfig = {
    ParameterName: DISTRIBUTOR_ID_LIST_PARAMETER_NAME,
    EndPoint: '/AccountIp/List/',
    label: 'dist_name',
    value: 'distributor_id',
    EntitiesListKey: 'Accounts',
    icon: 'IconAccounts'
}

const campaignIvrListConfig = {
    ParameterName: CAMPAIGN_IVR_LIST_PARAMETER_NAME,
    EndPoint: '/Campaigns/List/',
    label: 'camp_name',
    value: 'camp_id',
    EntitiesListKey: 'Campaigns',
    icon: 'IconAccounts',
    filterByType: 'ivr'
}

const exitTypesConfig = {
    ParameterName: EXIT_TYPES_LIST_PARAMETER_NAME,
    label: 'Key',
    value: 'Value',
    EntitiesListKey: 'ItemList',
    icon: 'IconQueues'
}
const callCustomVarsConfig = {
    ParameterName: CALL_CUSTOM_VARS_LIST_PARAMETER_NAME,
    EndPoint: '/WidgetParameter/CallsCustomVariablesList/',
    label: 'label',
    value: 'value',
    EntitiesListKey: 'ItemList',
    icon: 'IconQueues',
    remote: true
}
const emotionListConfig = {
    ParameterName: EMOTION_LIST_PARAMETER_NAME,
    EndPoint: '/WidgetParameter/EmotionsList/',
    label: 'label',
    value: 'value',
    EntitiesListKey: 'ItemList',
    icon: 'IconQueues',
    remote: true
}
const clientPhoneConfig = {
    ParameterName: CLIENT_PHONE_PARAMETER_NAME,
    EndPoint: '/WidgetParameter/ClientPhoneList/',
    label: 'label',
    value: 'value',
    EntitiesListKey: 'ItemList',
    icon: 'IconQueues',
    remote: true
}

const questionsConfig = {
    ParameterName: QUESTIONS_PARAMETER_NAME,
    label: 'CategoryName',
    value: 'CategoryID',
    EntitiesListKey: 'AiCategories',
    icon: 'IconAccounts'
}

const layersConfig = {
    ParameterName: LAYERS_PARAMETER_NAME,
    label: 'layer_name',
    value: 'layer_id',
    EntitiesListKey: 'Layers',
}

export const ENTITY_TYPE_AUTOMATIC = 'ENTITY_TYPE_AUTOMATIC'
export const ENTITY_TYPE_IVR = 'ENTITY_TYPE_IVR'
const ENTITY_TYPE_ALL = 'ENTITY_TYPE_ALL'

export const entityTypesList = {
    [ENTITY_TYPE_AUTOMATIC]: 10,
    [ENTITY_TYPE_IVR]: 11,
    [ENTITY_TYPE_ALL]: 12,
}

export const filters = {
    [USER_LIST_PARAMETER_NAME]: userListConfig,
    [CAMPAIGN_LIST_PARAMETER_NAME]: campaignListConfig,
    [EXTENSION_LIST_PARAMETER_NAME]: extensionListConfig,
    [DID_LIST_PARAMETER_NAME]: didListConfig,
    [QUEUE_LIST_PARAMETER_NAME]: queueListConfig,
    [DISTRIBUTOR_ID_LIST_PARAMETER_NAME]: accountListConfig,
    '{|automaticcampaign_list|}': campaignListConfig,
    [CAMPAIGN_IVR_LIST_PARAMETER_NAME]: campaignIvrListConfig,
    [EXIT_TYPES_LIST_PARAMETER_NAME]: exitTypesConfig,
    [CALL_CUSTOM_VARS_LIST_PARAMETER_NAME]: callCustomVarsConfig,
    [EMOTION_LIST_PARAMETER_NAME]: emotionListConfig,
    [CLIENT_PHONE_PARAMETER_NAME]: clientPhoneConfig,
    [VOICEBOT_LIST_PARAMETR_NAME]: voicebotListConfig,
    [QUESTIONS_PARAMETER_NAME]: questionsConfig,
    [LAYERS_PARAMETER_NAME]: layersConfig,
}

export const summaryCdrTemplateConfig = {
    ParameterName: SUMMARY_CDR_TEMPLATE_PARAMETER_NAME,
    label: 'label',
    value: 'value',
    ParameterType: 20
}

export const otherFilters = {
    2: {
        ParameterName: '{|chart_field_end_hour_day|}',
        ParameterType: 2,
    },
    3: {
        ParameterName: '{|chart_field_start_hour_day|}',
        ParameterType: 2,
    },
    6: {
        ParameterName: '{|target_duration|}',
        ParameterType: 2,
    },
    13: {
        ParameterName: '{|Abonden_Sec_max|}',
        ParameterType: 4,
    },
    14: {
        ParameterName: '{|Abonden_Sec|}',
        ParameterType: 4,
    },
    15: {
        ParameterName: '{|SLA_Time|}',
        ParameterType: 4,
    },
    16: {
        ParameterName: '{|SLA_Time_B|}',
        ParameterType: 4,
    },
    17: {
        ParameterName: '{|SLA_Time_C|}',
        ParameterType: 4,
    },
    20: {
        ParameterName: '{|CustomDuration|}',
        ParameterType: 2,
    },
    22: {
        ParameterName: '{|Success_duartion|}',
        ParameterType: 2,
    },
    23: {
        ParameterName: '{|Recurring_Calls_Thresh|}',
        ParameterType: 2,
    },
    24: {
        ParameterName: '{|MaxPostAbandonmentTime|}',
        ParameterType: 2,
    },
    27: {
        ParameterName: '{|HoursOfWorkPerDay|}',
        ParameterType: 2,
    },
    28: {
        ParameterName: '{|LastCallDelayMinAlert|}',
        ParameterType: 2,
    },
    29: {
        ParameterName: '{|LunchTimeAlert|}',
        ParameterType: 2,
    },
    30: {
        ParameterName: '{|ShiftOffsetTime|}',
        ParameterType: 2,
    },
    31: {
        ParameterName: '{|OffsetTimeTest|}',
        ParameterType: 2,
    },
}
